import styled from "@emotion/styled";
import Menu from "@engineering/icons/menu";
import User from "@engineering/icons/user";
import { HeaderIconStyles } from "@silvertours/front-entities";
var Header = /*#__PURE__*/ styled("header", {
    target: "eqpkj1r0"
})("height:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";position:relative;z-index:30;display:flex;align-items:center;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{height:", function(param) {
    var theme = param.theme;
    return theme.spacing[100];
}, ";z-index:auto;}");
var MenuIcon = /*#__PURE__*/ styled(Menu, {
    target: "eqpkj1r1"
})(HeaderIconStyles, ";/* For accessibility reasons,the menu icon should be slightly bigger. */\n  width:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";height:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";");
var Separator = /*#__PURE__*/ styled("hr", {
    target: "eqpkj1r2"
})("height:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";width:2px;flex:none;border:0;background-color:#5e6e6a;display:block;margin-right:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");
var UserIcon = /*#__PURE__*/ styled(User, {
    target: "eqpkj1r3"
})(HeaderIconStyles);
var IconButtonContainer = /*#__PURE__*/ styled("div", {
    target: "eqpkj1r4"
})("display:flex;color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";");
var ActionArea = /*#__PURE__*/ styled("div", {
    target: "eqpkj1r5"
})("display:flex;flex-grow:1;margin-left:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";justify-content:flex-end;");
var DesktopActions = /*#__PURE__*/ styled("div", {
    target: "eqpkj1r6"
})("display:grid;grid-template-columns:1fr auto;align-items:center;width:100%;gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");
var ActionButtons = /*#__PURE__*/ styled("div", {
    target: "eqpkj1r7"
})("align-items:center;display:flex;gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");
export { ActionArea, ActionButtons, DesktopActions, Header, IconButtonContainer, MenuIcon, Separator, UserIcon };
